module.exports = __webpack_public_path__ + "static/KC6-fee83413a51b2e1e795beda5ec1648fc.png";